<template>
  <ion-page>
    <ion-header>
      <ion-toolbar>
        <ion-title>Administración</ion-title>
      </ion-toolbar>
    </ion-header>
    <ion-content :fullscreen="true" class="ion-padding">
      <ion-header collapse="condense">
        <ion-toolbar>
          <ion-title size="large">Administración</ion-title>
        </ion-toolbar>
      </ion-header>
      <p>Este espacio es para la administración de la aplicación</p>
      <ion-button @click="report()">Obtener listado</ion-button>
      <ion-button @click="reportDoc()">Obtener listado Doc</ion-button>
      <ion-button @click="out()">Salir como administrador</ion-button>
      
    </ion-content>
  </ion-page>
</template>

<script lang="ts">
import { IonButton, IonPage, IonHeader, IonToolbar, IonTitle, IonContent } from '@ionic/vue';
import Config from  '@/assets/Config';
import Contact from '@/model/Contact';

export default  {
  name: 'Tab3',
  components: {  IonButton, IonHeader, IonToolbar, IonTitle, IonContent, IonPage },

  setup(){

    const report = ()=>{
        window.location.href=Config.URL+'/export/'+Contact.phone+'/'+Contact.dni;
    }
    
    const reportDoc = ()=>{
        window.location.href=Config.URL+'/doc/'+Contact.phone+'/'+Contact.dni;
    }

    const out = ()=>{
        Contact.authorized=false;
        Contact.dni='';
        Contact.phone='';
    }

      return {
          report,
          reportDoc,
          out
      }

  }
}
</script>